import { Dispatch, SetStateAction } from "react";
import {
  API_URL,
  v,
  put,
  debug,
  request,
  takeEvery,
  createDoRequestAction,
  assertTotalSchema,
  SagaIterator,
  call,
  RequestResult,
} from "../../lib";

import { doMETHOD_UPDATE_TASK, doREQUEST_ERROR, doREQUEST_COMPLETE } from "../state";
import { getToken } from "./token_fetcher";

export const REQUEST_TASK_TIMER_UPDATE = "REQUEST_TASK_TIMER_UPDATE";
export const doREQUEST_TASK_TIMER_UPDATE = createDoRequestAction(REQUEST_TASK_TIMER_UPDATE);

export const requestTaskTimerUpdateActionCreators = {
  doREQUEST_TASK_TIMER_UPDATE,
};

interface Payload {
  payload: {
    requestId: string;
    name: string;
    description: string;
    scheduleRepeat: boolean;
    scheduleDescription: string;
    reminderList?: Record<string, string>[];
    taskId: string;
    color: string;
  };
  setRequestResult?: Dispatch<SetStateAction<RequestResult | null>>;
}

export function* requestTaskTimerUpdate({ payload, setRequestResult }: Payload): SagaIterator {
  debug("saga*requestTaskTimerUpdate");

  try {
    assertTotalSchema({
      payload,
      schema: v.object({
        requestId: v.string().uuid().optional(),
        name: v.string().optional(),
        description: v.string().optional(),
        scheduleRepeat: v.boolean().optional(),
        scheduleDescription: v.string().optional(),
        reminderList: v.array().optional(),
        taskId: v.string().uuid().exist(),
        color: v.string().optional(),
      }),
    });
  } catch (error) {
    return yield put(
      doREQUEST_ERROR({
        fromType: REQUEST_TASK_TIMER_UPDATE,
        requestId: payload.requestId,
        error,
      }),
    );
  }

  const { name, description, scheduleRepeat, scheduleDescription, reminderList, taskId, color } =
    payload;

  const accessToken = yield call(getToken);

  const result = yield request({
    method: "post",
    url: `${API_URL}/v1/web/task-timer-update`,
    accessToken,
    data: {
      name,
      description,
      scheduleRepeat,
      scheduleDescription,
      reminderList,
      taskId,
      color,
    },
  });

  if (!result.success || result.error) {
    const error = result.error || new Error("request did not succeed");
    debug(error);
    return yield put(
      doREQUEST_ERROR(
        {
          fromType: REQUEST_TASK_TIMER_UPDATE,
          fromPayload: payload,
          requestId: payload.requestId,
          url: "/v1/web/task-timer-update",
          ...result,
          error,
        },
        setRequestResult,
      ),
    );
  }

  delete result.payload.enabled;
  yield put(doMETHOD_UPDATE_TASK(result.payload));

  yield put(
    doREQUEST_COMPLETE(
      {
        fromType: REQUEST_TASK_TIMER_UPDATE,
        requestId: payload.requestId,
        ...result,
      },
      setRequestResult,
    ),
  );
}

export function* taskTimerUpdateSaga() {
  yield takeEvery(REQUEST_TASK_TIMER_UPDATE as any, requestTaskTimerUpdate);
}
